import FlechaIzquierdaIcon from "../../../assets/images/generico/FlechaIzquierdaIcon";
import "./PreguntasFrecuentes.css";

const PreguntasFrecuentes = ({ item, selected, handleClickMenu }) => {
  const isOpen = selected === item.id;
  return (
    <div className="ptur-preguntasFrecuentes-card">
      <ul className="ptur-list-preguntasFrecuentes">
        <li
          className={`ptur-option-preguntasFrecuentes${isOpen ? " is-open" : ""}`}
          onClick={handleClickMenu}
        >
          <div className="ptur-preguntasFrecuentes-tituloFlecha rb16b">
            <span>{item.pregunta}</span>
            <div className={`ptur-preguntasFrecuentes-chevron${isOpen ? " is-open" : ""}`}>
              <FlechaIzquierdaIcon />
            </div>
          </div>
          {isOpen && (
            <div className="ptur-preguntasFrecuentes-textoCard">
              <div
                className="content rb14l"
                dangerouslySetInnerHTML={{ __html: item.respuesta }}
              />
            </div>
          )}
        </li>
      </ul>
    </div>
  );
};

export default PreguntasFrecuentes;
